import React, { createContext, useContext, useRef, useState } from 'react';

export const MyContext = createContext();

export const MyProvider = ({ children }) => {
  const [sharedData, setSharedData] = useState({ElasticCount:0});
  let countdata=useRef(0);

  return (
    <MyContext.Provider value={{ sharedData, setSharedData,countdata }}>
      {children}
    </MyContext.Provider>
  );
};
export const useUser = () => useContext(MyContext);